module.exports = __webpack_public_path__ + "static/zigzag-image5-03c1424737ce7142512f09d553a63062.png";